module.exports = __webpack_public_path__ + "assets/monsterinsights.d6dc486f.svg";